import { styled } from "@mui/material/styles";
import { Box, IconButton, Typography } from "@mui/material";

export const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  padding: theme.spacing(4),
  width: "100%",
  maxWidth: 600,
  boxShadow: theme.shadows[5],
  borderRadius: theme.spacing(1),
}));

export const ModalHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const ModalTitle = styled(Typography)({
  fontSize: "24px",
  fontWeight: 600,
});

export const ModalDescription = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: theme.palette.secondary.main,
}));

export const CloseButton = styled(IconButton)({
  alignSelf: "flex-start",
});

export const ActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: theme.spacing(2),
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.colors.action.failure,
  marginTop: theme.spacing(1),
}));
